import { SLOT_STATES, ABOUT_TO_EXPIRE_RATIO } from '@/store/static/phuProduction'

export const resolveSlotState = (slot, now) => {
    if (!slot.product_id) {
        return SLOT_STATES.DISABLED
    }
    if (!slot.units) {
        return SLOT_STATES.EMPTY
    }
    if (now < slot.ready_at) {
        return SLOT_STATES.COOKING
    }
    if (now >= slot.expires_at) {
        return SLOT_STATES.EXPIRED
    }

    const holdingDuration = slot.expires_at - slot.ready_at
    const remaining = slot.expires_at - now

    return remaining <= holdingDuration * ABOUT_TO_EXPIRE_RATIO ? SLOT_STATES.ABOUT_TO_EXPIRE : SLOT_STATES.READY
}

export const WASTABLE_STATES = [SLOT_STATES.READY, SLOT_STATES.ABOUT_TO_EXPIRE, SLOT_STATES.EXPIRED]
